import { PromoEntity } from '@promo/const';
import { StateUtils } from '@spartacus/core';

export const PROMO_FEATURE = 'promo';
export const PROMO_ENTITY = '[Promo] Promo Entity';
export const EMAIL_SUBSCRIPTION_ENTITY = '[Promo] Email Subscription Entity';

export interface StateWithPromo {
  [PROMO_FEATURE]: PromoState;
}

export interface PromoState {
  promo: StateUtils.LoaderState<PromoEntity>;
  emailSubscription: StateUtils.LoaderState<boolean>;
}
